/**
 * SubformulaCardHeader — collapse, title + expression, remove
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import WeightStepper from '../../../group/header/WeightStepper';

import SubformulaTitleAndExpression from '../SubformulaTitleAndExpression';
import SubformulaHeaderCollapseToggle from './SubformulaHeaderCollapseToggle';
import SubformulaHeaderRemoveButton from './SubformulaHeaderRemoveButton';

export interface SubformulaCardHeaderProps {
  bodyId: string;
  expanded: boolean;
  onToggleExpanded: () => void;
  name: string;
  onNameChange: (next: string) => void;
  expression: string;
  weight: number;
  onWeightChange: (next: number) => void;
  onRemove: () => void;
}

const SubformulaCardHeader: FC<SubformulaCardHeaderProps> = ({
  bodyId,
  expanded,
  onToggleExpanded,
  name,
  onNameChange,
  expression,
  weight,
  onWeightChange,
  onRemove,
}) => (
  <div className="flex items-center gap-2">
    <SubformulaHeaderCollapseToggle
      bodyId={bodyId}
      expanded={expanded}
      onToggle={onToggleExpanded}
    />
    <SubformulaTitleAndExpression
      name={name}
      onNameChange={onNameChange}
      expression={expression}
    />
    <span className="flex shrink-0 items-center gap-1">
      <span className="text-[10px] font-medium uppercase tracking-wide text-muted-foreground">
        Weight
      </span>
      <WeightStepper
        weight={weight}
        onChange={onWeightChange}
        ariaLabel={`Weight for ${name || 'sub-formula'}, percent`}
      />
    </span>
    <SubformulaHeaderRemoveButton onRemove={onRemove} />
  </div>
);

export default SubformulaCardHeader;
